<glxy-form-field suffixIcon="search" class="search-bar">
  <input type="text" matInput automataMatInputAutofocusDelayed [formControl]="searchControl" />
</glxy-form-field>

<div class="list-container">
  <ng-container *ngFor="let snippet of snippets$$ | async">
    <div
      class="snippet-container"
      [ngClass]="{ 'snippet-container-valid': snippet.valid, 'snippet-container-invalid': !snippet.valid }"
      (click)="openSnippet(snippet)"
    >
      <div class="snippet-name">
        {{ snippet.automation.name }}
      </div>
      <span class="icon-and-badge">
        @if (!snippet.valid) {
          <mat-icon
            class="warning-icon"
            [glxyTooltip]="'AUTOMATIONS.EDITOR.ADD_STEPS_LIST.MISSING_INFO'"
            [tooltipPositions]="TOOLTIP_TOP_LEFT"
            >warning</mat-icon
          >
        }
        <glxy-badge class="snippet-badge" [size]="'small'">{{ snippet.automation.workflow?.length || 0 }}</glxy-badge>
      </span>
    </div>
  </ng-container>
  @if (isLoading) {
    <ng-container *ngTemplateOutlet="loading"></ng-container>
  }
  <!-- No results after search -->
  @if ((snippets$$ | async)?.length === 0 && !isLoading && (searchValue$ | async) !== '') {
    {{ 'COMMON.NO_RESULTS_FOUND' | translate }}
  }
  <!-- They have no snippets (empty state) -->
  @if ((snippets$$ | async)?.length === 0 && !isLoading && (searchValue$ | async) === '') {
    <glxy-empty-state [size]="'small'">
      <glxy-empty-state-hero>
        <div class="empty-state-image"></div>
      </glxy-empty-state-hero>
      <glxy-empty-state-title>
        {{ 'AUTOMATIONS.EDITOR.ADD_STEPS_LIST.EMPTY_STATE_TITLE' | translate }}
      </glxy-empty-state-title>
      <p>
        {{ 'AUTOMATIONS.EDITOR.ADD_STEPS_LIST.EMPTY_STATE_BODY' | translate }}
      </p>
    </glxy-empty-state>
  }
  <glxy-infinite-scroll-trigger (isVisible)="loadMore()"></glxy-infinite-scroll-trigger>
</div>

<ng-template #loading>
  <glxy-loading-spinner [fullWidth]="true"></glxy-loading-spinner>
</ng-template>
